import { render, staticRenderFns } from "./sizes.vue?vue&type=template&id=3077f848&scoped=true&"
import script from "./sizes.vue?vue&type=script&lang=js&"
export * from "./sizes.vue?vue&type=script&lang=js&"
import style0 from "./sizes.vue?vue&type=style&index=0&id=3077f848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077f848",
  null
  
)

export default component.exports